"use client"

import { useEffect } from "react"
import { toast } from "sonner"

export function PwaRegistrar() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    // updateViaCache: 'none' ensures the browser always fetches sw.js fresh
    // rather than serving it from HTTP cache — critical for catching deploys.
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        // Periodically poll for SW updates (every 60s) in case the page is
        // long-lived (e.g. PWA left open overnight).
        const interval = setInterval(() => registration.update(), 60_000)
        return () => clearInterval(interval)
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error)
      })

    // When the SW posts SW_UPDATED (after activate + clients.claim), prompt
    // the user to reload so the new JS chunks are loaded from the fresh SW.
    const onMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SW_UPDATED') {
        toast('Update available', {
          description: 'A new version of Algoglide is ready.',
          action: {
            label: 'Reload',
            onClick: () => window.location.reload(),
          },
          duration: Infinity,
        })
      }
    }

    navigator.serviceWorker.addEventListener('message', onMessage)
    return () => navigator.serviceWorker.removeEventListener('message', onMessage)
  }, [])

  return null
}
